import React, { Fragment } from 'react';
import styled from 'styled-components';

import Styles from './ShuttlePassenger.Styles';
import ValidateButton from '../TicketsWhite/ValidateButton';
import Text from '../../base/Text';
import InputsField from '../../base/InputsFieldFlat';
import gettingData from '../../../assets/images/clock.gif';

const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const InputsWrapper = styled.div`${Styles.inputsWrapper};`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const Info = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.info}`; // prettier-ignore
const PriceContainer = styled.div`${Styles.priceContainer}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;
const Line = styled.div`${Styles.line}`;


// eslint-disable-next-line require-jsdoc
const Item = ({
  n, shuttleInfo, onShuttleUpdate, translations, isSorting, hasBlackTheme, quantityBaggage, baggagesData, data
}) => {
  const {
    nameShuttle, lastNameShuttle, emailShuttle, baggageShuttle
  } = shuttleInfo;

  const isBaggageEnabled = baggagesData && baggagesData.baggageMapEnabled;
  let baggageMap = {};
  let extraBaggageCharge = 0.0;
  if (isBaggageEnabled) {
    baggageMap = baggagesData.baggageMap[0];
    extraBaggageCharge = parseFloat(baggageMap.extraFee);
  }
  return (
    <div style={{ width: '100%' }}>
      <Info className="col-12">{translations.passenger}{parseInt(n, 10) + 1}</Info>
      <Column style={{ flex: 9 }}>
        <Row style={{ justifyContent: 'flex-start', margin: 0 }}>
          <InputsWrapper style={{ flex: 2 }}>
            <LabelInput>{translations.name.label}</LabelInput>
            <InputsField
              value={nameShuttle}
              status={nameShuttle ? (nameShuttle.match(/^(?:[A-Za-zÀ-ÖØ-öø-ÿ]+\s*)+$/) ? 1 : 2) : 0}
              onChange={e => onShuttleUpdate(n, 'nameShuttle', e.target.value)}
            />
          </InputsWrapper>
          <InputsWrapper style={{ flex: 2 }}>
            <LabelInput> {translations.lastName.label}</LabelInput>
            <InputsField
              status={lastNameShuttle ? (lastNameShuttle.match(/^(?:[A-Za-zÀ-ÖØ-öø-ÿ]+\s*)+$/) ? 1 : 2) : 0}
              value={lastNameShuttle}
              onChange={e => onShuttleUpdate(n, 'lastNameShuttle', e.target.value)}
            />
          </InputsWrapper>
        </Row>
        <Row style={{ justifyContent: 'flex-start', margin: '15px 0px'}}>
          <InputsWrapper style={{ flex: 0.5 }}>
            <LabelInput>{translations.email.label}</LabelInput>
            <InputsField
              type="email"
              value={emailShuttle}
              status={emailShuttle ? (emailShuttle.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : 2) : 0}
              onChange={(e) => { onShuttleUpdate(n, 'emailShuttle', e.target.value); }}
            />
          </InputsWrapper>
          {isBaggageEnabled && (
          <InputsWrapper style={{ flex: 0.3, width: '50%' }}>
            <LabelInput>{`${translations.baggage}`}</LabelInput>
            <Select
              onChange={e => onShuttleUpdate(n, 'baggageShuttle', e.target.value)}
              status={baggageShuttle ? (baggageShuttle >= 0 ? 1 : 2) : 0}
              value={baggageShuttle}
              hasBlackTheme={hasBlackTheme}
              isSorting={isSorting}
            >
              <option value="" key="empty" selected>{translations.shuttleBaggageLabel}</option>
              {quantityBaggage && quantityBaggage.filter(option => (option.value <= baggageMap.maxQty)).map((option, idx) => {
                // eslint-disable-next-line react/no-array-index-key
                const extraBaggages = Math.max(0, option.value - baggageMap.maxQtyWithoutCharge);
                const extraCharge = extraBaggages * extraBaggageCharge;
                return (
                  <option value={option.value} key={`inputValue${idx}${option.value}`}>
                    {`${option.name} ($${extraCharge.toFixed(2)} USD)`}
                  </option>
                );
              })}
            </Select>
          </InputsWrapper>
          )}
        </Row>
        <Line style={{ justifyContent: 'flex-start', width: '100%' }}/>
      </Column>
    </div>);
};

/**
* TicketInfo component
* @returns {JSX.Element}
*/const ShuttlePassenger = ({
    translations,
    initializeCounter,
    onShuttleUpdate,
    isCallingParkingApi,
    buyingToggle, 
    ticketNumber, 
    enableSendToCartShuttle,
    enableSendToCartShuttleABC,
    quantityBaggage,
    openShuttleSelectSeats, 
    shuttlePassengers, 
    goToPersonalInfo
  }) => {
  
  let cars = [];
  let shuttleData = [];
  let shuttleRoutesData = {data:{provider:''}};
  let baggagesData = {};
  if (typeof window !== 'undefined') {
    shuttleData = JSON.parse(window.localStorage.getItem('shuttle'));
    shuttleRoutesData = JSON.parse(window.localStorage.getItem('shuttle_data'));
    baggagesData = JSON.parse(window.localStorage.getItem('CBX_Shuttle_Details')).data;
  }

  if (shuttleData) {
    const { shuttles } = shuttleData;
    if (shuttles) {
      if (shuttles.length > 0) {
        cars = [...shuttles];
        initializeCounter(Math.max(shuttles.length, shuttlePassengers));
      }
    }
  }

  // eslint-disable-next-line require-jsdoc
  const generateRows = (counter, vInfo) => {
    const rows = [];
    for (let i = 0; i < counter; i += 1) {
      const baseShuttle = {
        nameShuttle: '',
        lastNameShuttle: '',
        emailShuttle: '',
        baggageShuttle: ''
      };
      let shuttleInfo = baseShuttle;
      if (typeof vInfo[i] === 'object' && vInfo[i] !== null) {
        shuttleInfo = {
          ...baseShuttle,
          ...vInfo[i],
        };
      }
      rows.push(
        <Item
          key={i}
          n={i}
          translations={translations}
          shuttleInfo={shuttleInfo}
          onShuttleUpdate={onShuttleUpdate}
          buyingToggle={buyingToggle}
          ticketNumber={ticketNumber}
          quantityBaggage={quantityBaggage}
          baggagesData={baggagesData}
          shuttlePassengers={counter}
          data={shuttleRoutesData.data.provider}
        />
      );
    }
    return rows;
  };

  return (
    <Fragment>
      <Fragment>
        {generateRows(shuttlePassengers, cars)}
        <PriceContainer>
          <Row>
            {false && (
              <ButtonContainer>
                <ValidateButton
                  disabled={false}
                  message={translations.editParking}
                  backgroundColor="#D8D8D8"
                  textColor="#726C79"
                />
              </ButtonContainer>
            )}
            <ButtonContainer>
              <ValidateButton
                disabled={shuttleRoutesData.data.provider === "damaris" ? !enableSendToCartShuttle : !enableSendToCartShuttleABC }
                message={translations.continueLabel}
                action={shuttleRoutesData.data.provider === "damaris" ? goToPersonalInfo : openShuttleSelectSeats}
              />
            </ButtonContainer>
          </Row>
        </PriceContainer>
      </Fragment>  
      {isCallingParkingApi && (
        <div
          style={{
            padding: '5%',
            width: '100%',
            margin: 'auto',
            justifyContent: 'center'
          }}
        >
          <img
            alt=""
            style={{ margin: 'auto', display: 'block ' }}
            width="150px"
            height="auto"
            src={gettingData}
          />
        </div>
      )}
    </Fragment>
  );
};
export default ShuttlePassenger;
